/*
 * Purpose : Locations config Landing page
 * Author : Soban
 * Copyright (c) - Globalfoundries 
 * 
 * Revision History
 * Version  | Date        | Author  | Description
 * -------------------------------------------------------------------------------------
 * 1.0      | 26-Oct-2021 | Soban   | Initial version
 * 
 */

import React,{ useState, useEffect } from 'react';
import {FaCheckCircle} from "react-icons/fa";
import {GoLocation} from "react-icons/go"
//import {AiFillCloseCircle, AiOutlineUserAdd} from "react-icons/ai";
import {AiFillCloseCircle} from "react-icons/ai";

import ReactTable from 'react-table';
import { Button, Alert, Modal, ModalBody, ModalHeader, Row, Col } from 'reactstrap'
import axios from 'axios';
//import { MdEdit, MdVisibility, MdDelete } from 'react-icons/md';
import uniqid from 'uniqid';

import "./Locations.css";
import Aux from '../../../hoc/Auxilliary/Auxilliary';
import {locationTableHeaders} from '../../../config/constants';
import LocationForm from '../../../components/locations/AddEditLocations';
import LoadingModal from '../../../components/UI/modals/loadingModal';
//amplify
import { API, graphqlOperation } from 'aws-amplify';
//import {createExcessuserroles, updateExcessuserroles} from '../../../graphql/mutations';
import ToolSalesButton from '../../../components/UI/Buttons/ToolSalesButton/ToolSalesButton';
import BackButton from '../../../components/UI/Buttons/BackButton/BackButton';
import DeleteAlertModal from '../../../components/UI/modals/DeleteAlertModal';



const Locations = () => {
    //console.log("UserManagement Component imported")
    const [loading, setLoading] = useState(false)
    const [modal, setModal] = useState(false);
    const [stateValues, setStateValues] = useState({});
    const [error, setError] = useState(null)
    const [success, setSuccess] = useState(null)
    const [deleteModal, setDeleteModal] = useState(false)
    const [row, setRow] = useState({})
    const [data, setData] = useState([])
    const [columns, setColumns] = useState([])

    const toggleModal = () => setModal(!modal);

    // get existing locations
    const getLocations = async() => {
        const q = `query 
                {listExcesslocationss(limit:${process.env.REACT_APP_USERROLES_TABLE_LIMIT}){
                    items{
                        id
                        location
                        enable
                    }
                }}`;
            const apiData =await API.graphql(graphqlOperation(q))
            //console.log("apiData==>",apiData)
            const results = apiData.data.listExcesslocationss.items;
            //console.log("results==>",results)
            const data = results.map(e => {
                const rec = { ...e }
                rec.actions = buildActions(e)
                return rec
            })
            console.log("data fetched")
            return data
    }
   
    // on submit add or edit location request
    const submithandler = async (id,location,enableFlag,action) => {
        // console.log("location=>",location)
        // console.log("enableFlag=>",enableFlag)
        
        let locationRecord = {
            id: id?id:uniqid.time(),
            location: location,
            enable: enableFlag?"Yes":"No"            
        }
        //locationRecord = JSON.stringify(locationRecord)
        //console.log("locationRecord=>",locationRecord)
        const createMutation = `mutation {
            createExcesslocations(input: {id: "${locationRecord.id}", location:"${locationRecord.location}", enable:"${locationRecord.enable}" }) {
                location
                id
            }
        }`
        const updateMutation = `mutation {
            updateExcesslocations(input: {id: "${locationRecord.id}", location:"${locationRecord.location}", enable:"${locationRecord.enable}" }) {
                location
                id
            }
        }`
        await API.graphql(graphqlOperation(action ==='add' ? createMutation:updateMutation))
        .then(async result =>
            {
                //console.log("result location create ==>",result)
                setModal(false)
                if(action==="add"){
                    setSuccess("Location was added successfully.!")
                }
                else{
                    setSuccess("Location was updated successfully.!")
                }
                const data = await getLocations()
                //console.log("data 2 =>",data)
                setData(data)
            }
        ).catch(error => {
            console.log("error create locations ==>",error.errors && error.errors[0].errorType)
            console.log("err while processing location submit=>", JSON.stringify(error, null, 4))
            const reqBody = {
                level:"error",
                message: "Error while processing location submit. error: "+JSON.stringify(error, null, 4)
            }
            axios.post( `${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                            reqBody,
                            { headers: {'x-api-key':process.env.REACT_APP_REST_API_KEY} }
                        );
            
            setModal(false)
            if(error.errors && error.errors[0].errorType.indexOf("ConditionalCheckFailedException") !== -1)
            {
                setError("Duplicate record found.! Please check and try again.!")
            }
            else{
                setError("There is some error.! Please try again.!")
            }
        });
    }
    
    // to add locations
    const addFormHandler = () =>{
        setStateValues({
            id:"",
            location:"",
            enable:"",
            action:"add"
        })
        setModal(true)
    }
    // to edit locations
    const editFormHandler = (editRow) =>{
        //console.log("row->",editRow)
        editRow.action="edit"
        setStateValues(editRow)
        setModal(true)
    }
    const confirmDelete = (row) => {
        setRow(row)
        setDeleteModal(true)
    }
    const deleteHandler = async (row) => {
        //console.log("row=>",row);
        setLoading(true)
        setDeleteModal(false)
        const q = `mutation {
                deleteExcesslocations(input: {id: "${row.id}" }) {
                    location
                    id
                }
            }`
        //console.log("q=>",q)
        const apiData =await API.graphql(graphqlOperation(q))
        //console.log("apiData=>",apiData.data.deleteExcessuserroles)
        setLoading(false)
        if(apiData.data.deleteExcesslocations && apiData.data.deleteExcesslocations!=null)
        {
            setSuccess(`Location : ${apiData.data.deleteExcesslocations.location} was removed successfully.!`)
            const data = await getLocations()
            //console.log("data 3 =>",data)
            setData(data)
        }
        else{
            console.log("err while deleting location=>", error)
            const reqBody = {
                level:"error",
                message: "Error while deleting location. error: "+error
            }
            axios.post( `${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                            reqBody,
                            { headers: {'x-api-key':process.env.REACT_APP_REST_API_KEY} }
                        );
            setError("Error while deleting the record.! Please try again.!")
            
        }
    }

    const buildActions = (tableRow) => {
        const actions = [];
        //console.log("tableRow=>",tableRow)
        actions.push(
            <div key={tableRow.id} className={"actionDivLoc"}>
                <Button className={"editBtnLoc"} color="warning" onClick={() => editFormHandler(tableRow) }>Edit{'  '}</Button>
                <Button className={"delBtnLoc"} color="danger" onClick={() => confirmDelete(tableRow)}>Delete</Button>
                {/* <div className={"mobileView"}>
                <Button key={"edit"}  outline size="sm" color="warning" onClick={() => editFormHandler(tableRow)} alt="Edit"><MdEdit /></Button>
                </div> */}
            </div>
        )
        return <div style={{width:"100%", textAlign:"center"}} key={"actions"} >{actions}</div>
    }
    
    useEffect( () => {
        setLoading(true)
        const buildData = async () => {
            // set Table Headers
            const columns = []
            Object.keys(locationTableHeaders).forEach((col, i) => {
                if (col.toLowerCase() === "actions") {
                    columns.push({
                        Header:locationTableHeaders[col],
                        accessor:col,
                        filterable:false,
                    })
                }
                else if(col === "enable"){
                    columns.push({
                        Header:locationTableHeaders[col],
                        accessor:col,
                        filterable:true,
                        Cell: e=> {
                            if(e.value==="Yes")
                                return <div style={{textAlign:"center"}}><FaCheckCircle color="green"/></div>
                            else
                                return <div style={{textAlign:"center"}}><AiFillCloseCircle color="red"/></div>
                        }
                    })
                }
                else{
                    columns.push({
                        Header:locationTableHeaders[col],
                        accessor:col,
                        filterable:true,
                    })
                }
            });
            setColumns(columns);
            const data = await getLocations()            
            // console.log("columns=>",columns)
            //console.log("data=>",data)
            setData(data)
            setLoading(false)
        }
        buildData()
    }, [] );

    return (
        <Aux>
            <Alert color="danger" isOpen={error!=null?true:false}>{error}</Alert>                    
            <Alert color="success" isOpen={success!=null?true:false}>{success}</Alert>                    
            <Modal isOpen={modal} toggle={toggleModal} size="lg" draggable={false} centered={true}>
                <ModalHeader>Add/Edit Location</ModalHeader>
                <ModalBody>
                    <LocationForm submithandler={submithandler} stateVals={stateValues} closeHandler={toggleModal}/>
                </ModalBody>
            </Modal>
            {/* <Modal isOpen={deleteModal} toggle={()=>setDeleteModal(false)}>
                <ModalHeader><font color="#ffc107">Delete Confirmation!</font></ModalHeader>
                <ModalBody>
                    <p>Are you sure you want to delete this record? You will not be able to undo this action.</p>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary"
                            style={{backgroundColor:"#fb8734", borderColor:"#fff", boxShadow:"0px 1px 2px 2px #C0C0C0"}} onClick={()=> deleteHandler(row)}>Delete</Button>{' '}
                    <Button color="secondary" onClick={()=>setDeleteModal(false)}>Cancel</Button>    
                </ModalFooter>
            </Modal> */}
            <DeleteAlertModal open={deleteModal} handler={setDeleteModal} deleteHandler={deleteHandler.bind(this,row)}/>
            <LoadingModal open={loading} msg="Loading..." />
            <div className="topBtnDivSetup">
                <Row form style={{ justifyContent: "flex-end" }}>
                    <Col md="auto">
                        <ToolSalesButton onClick={addFormHandler} >
                            <GoLocation style={{fontSize:"20px"}} />&nbsp;&nbsp;Add Location
                        </ToolSalesButton>
                    </Col>
                    <Col md="auto">
                        <BackButton path="/setup" label="Go Back"/>
                    </Col>
                </Row>
            </div>     
            { data.length !== 0 ? 
                <div style={ {margin: "0% 2%", width: "-webkit-fill-available !important" } }>                           
                    <ReactTable data={data} columns={columns} defaultPageSize={10} />
                </div>
                : <div className={"noDataDiv"}><p>No data Found.!</p></div> }                    
        </Aux>
    )
}
export default Locations;